import type React from "react";

type Props = {
	children: React.ReactNode;
};
export default function SimpleLayout({ children }: Props) {
	return <div className="min-h-screen w-full text-text-base bg-bg">{children}</div>;
}
